import { render, staticRenderFns } from "./ThemeCustom.vue?vue&type=template&id=3796ce82&scoped=true&"
import script from "./ThemeCustom.vue?vue&type=script&lang=js&"
export * from "./ThemeCustom.vue?vue&type=script&lang=js&"
import style0 from "./ThemeCustom.vue?vue&type=style&index=0&id=3796ce82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3796ce82",
  null
  
)

export default component.exports